var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-hawb", {
    ref: "hawb",
    attrs: {
      context: _vm.context,
      action: _vm.action,
      job: _vm.job,
      form: _vm.form,
      "cooperate-edit": _vm.cooperateEdit
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }